<template>
  <div class="SetConsultTarget">
    <el-dialog
      :title="'请设定本月目标(' + date2 + ')'"
      :visible.sync="dialogVisible2"
      width="25%"
      :before-close="handleAddDrawerBeforeClose2">
      <div class="contents">
        <el-row  class="mb-10">
          <el-col :span="4" class="m-label">云上</el-col>
          <el-col :span="20">
            <el-input type="number" v-model="consult_cloud" size="small" placeholder="输入本月云上目标数量" />
          </el-col>
        </el-row>
        <el-row  class="mb-10">
          <el-col :span="4" class="m-label">套餐</el-col>
          <el-col :span="20">
            <el-input type="number" v-model="consult_combo" size="small" placeholder="输入本月套餐目标数量" />
          </el-col>
        </el-row>
        <el-row  class="mb-10">
          <el-col :span="4" class="m-label">单品</el-col>
          <el-col :span="20">
            <el-input type="number"  v-model="consult_item" size="small" placeholder="输入本月单品目标数量" />
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button v-if="false" size="mini" @click="HandleDialogVisibleClose">取 消</el-button>
    <el-button size="mini" type="primary" @click="HandleDialogVisible2">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SetConsultTarget',
  data () {
    return {
      dialogVisible2: false,
      consult_cloud: '',
      consult_combo: '',
      consult_item: '',
      status: false
    }
  },
  props: {
    date2: String
  },
  mounted () {},
  methods: {
    HandleDialogVisible2 () {
      if (!this.consult_cloud) {
        this.$message.error('请输入云上数量')
        return
      }
      if (!this.consult_combo) {
        this.$message.error('请输入套餐数量')
        return
      }
      if (!this.consult_item) {
        this.$message.error('请输入单品数量')
        return
      }
      if (this.consult_cloud === '0') {
        this.$message.error('云上数量不能为0')
        return
      }
      if (this.consult_combo === '0') {
        this.$message.error('套餐数量不能为0')
        return
      }
      if (this.consult_item === '0') {
        this.$message.error('单品数量不能为0')
        return
      }
      if (parseInt(this.consult_cloud) < 0) {
        this.$message.error('云上数量不能负数')
        return
      }
      if (parseInt(this.consult_combo) < 0) {
        this.$message.error('套餐数量不能负数')
        return
      }
      if (parseInt(this.consult_item) < 0) {
        this.$message.error('单品数量不能负数')
        return
      }
      this.$axios.post('/api/target/set_consult_target', {
        consult_cloud: this.consult_cloud,
        consult_combo: this.consult_combo,
        consult_item: this.consult_item
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.dialogVisible2 = data.data.status ? this.status : true
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleAddDrawerBeforeClose2 (done) {
      // this.$confirm('确认关闭?')
      //   .then(_ => {
      //     this.clearAddData()
      //     done()
      //   })
      //   .catch(_ => {})
    },
    clearAddData () {
      this.dialogVisible2 = false
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .SetConsultTarget
    marginLeft()
    position absolute
    left 0
    right 0
    top 0
    bottom 0
    margin 0 auto
  .mb-10
    margin-bottom: .2rem
    margin-top: 0.4rem;
  .m-label
    line-height: .64rem
</style>



// WEBPACK FOOTER //
// src/common/SetConsultTarget.vue